import Member from "../../models/Member";
import {WhiteBox} from "./WhiteBox";
import {Box, Grid} from "@mui/material";
import {VoterIcon} from "./VoterIcon";

interface VoterOverviewProps {
    voters: Member[];
}

export const VoterOverview: React.FC<VoterOverviewProps> = ({voters}) => {
    if (voters.length === 0) {
        return <></>;
    }

    return (
        <WhiteBox>
            <span>지금까지 투표한 사람 <span className={"highlight-text"}>{voters.length}</span></span>
            <Box height={"12px"} />
            <Grid container rowSpacing={2}>
                {voters.map((voter, index) => (
                    <Grid container item direction={'column'} alignItems={'center'} xs={2} key={index}>
                        <VoterIcon member={voter}/>
                    </Grid>
                ))}
            </Grid>
        </WhiteBox>
    );
}